module.exports = __webpack_public_path__ + "static/media/hoc3.571efc7f.jpg";